<template>
	<svg viewBox="0 0 20 20"
        :height="`${size}px`"
        :width="`${size}px`"
        :class="{ 'icon--light':  color === 'light', 'icon--dark':  color === 'dark', 'icon--primary':  color==='primary' }"
        >
		<title>
			Photo cover
		</title>
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1" >
				<path class="icon__stroke" d="M19,1V19H1V1H19m1-1H0V20H20V0Z" />
                <path class="icon__stroke" d="M10,7.42A2.58,2.58,0,1,1,7.42,10,2.59,2.59,0,0,1,10,7.42m0-.75A3.33,3.33,0,1,0,13.33,10,3.33,3.33,0,0,0,10,6.67Z" />
			</g>
		</g>
	</svg>
</template>

<script>
export default {
    name: "IconSetCover",
    props: {
        size: {
            type: Number,
            default: 15,
        },
        color: {
            type: String,
            default: 'light'
        }
    },
};
</script>
<style lang="scss" scoped>
    @import '../../../assets/scss/all';
    .icon {
        transition: stroke 0.2s ease-in-out;
        &--light {
            color: white;

            &:hover {
                color: $primary;
            }
        }

        &--dark {
            color: $dark;

            &:hover {
                color: $primary;
            }
        }

        &--primary {
            color: $primary;

            &:hover {
                color: lighten( $primary, 10% );
            }
        }

        &__stroke {
            stroke: currentColor;
        }
    }
</style>